import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideChevronDown } from '@ng-icons/lucide';
import { HlmIcon } from '@spartan-ng/helm/icon';
import { hlm } from '@spartan-ng/helm/utils';
import type { ClassValue } from 'clsx';

@Component({
  selector: 'hlm-select-scroll-down',
  imports: [NgIcon, HlmIcon],
  providers: [provideIcons({ lucideChevronDown })],
  host: {
    '[class]': '_computedClass()',
  },
  template: ` <ng-icon class="ml-2" hlm size="sm" name="lucideChevronDown" /> `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HlmSelectScrollDown {
  public readonly userClass = input<ClassValue>('', { alias: 'class' });
  protected readonly _computedClass = computed(() =>
    hlm('flex cursor-default items-center justify-center py-1', this.userClass()),
  );
}
